import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28.995 8.824A3 3 0 0 0 26 6H6l-.176.005A3 3 0 0 0 3 9v14l.005.176A3 3 0 0 0 6 26h20l.176-.005A3 3 0 0 0 29 23V9zM6 8h20l.117.007A1 1 0 0 1 27 9v14l-.007.117A1 1 0 0 1 26 24H6l-.117-.007A1 1 0 0 1 5 23V9l.007-.117A1 1 0 0 1 6 8m7 4a1 1 0 0 1 1.458-.89l.097.058 6 4a1 1 0 0 1 .104 1.585l-.104.08-6 4a1 1 0 0 1-1.55-.721L13 20zm2 6.13v-4.261L18.196 16z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconVideos = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconVideos);
export default Memo;
